import React, { useState } from "react";
import { motion } from "framer-motion";
import { MapPin, Mail, Phone, ArrowRight, CheckCircle } from "lucide-react";

export default function Contact() {

const [formData, setFormData] = useState({
name: "",
email: "",
message: ""
});

const [submitted, setSubmitted] = useState(false);

const contactInfo = [
{
icon: MapPin,
title: "Address",
content: "No. 18, 7th Main Street",
detail: "Vallalar Nagar, Pattabiram Chennai – 600072.",
color: "text-red-500"
},
{
icon: Mail,
title: "Email",
content: "[malarkrishnanbussiness@gmail.com](mailto:malarkrishnanbussiness@gmail.com)",
detail: "Response within 24 hours",
color: "text-blue-600"
},
{
icon: Phone,
title: "Phone",
content: "+91 97910-78708",
detail: "Mon - Fri, 9AM - 6PM",
color: "text-green-600"
}
];

const handleChange = (e) => {
const { name, value } = e.target;
setFormData(prev => ({
  ...prev,
  [name]: value
}));

};

const handleSubmit = (e) => {
e.preventDefault();if (!formData.name || !formData.email || !formData.message) return;

setSubmitted(true);

setFormData({
  name: "",
  email: "",
  message: ""
});

setTimeout(() => setSubmitted(false), 4000);

};

return (

<motion.section
  initial={{ opacity: 0, y: 40 }}
  animate={{ opacity: 1, y: 0 }}
  transition={{ duration: 0.6 }}
  className="bg-white py-24 px-6"
>

  <div className="max-w-7xl mx-auto">

    {/* Heading */}
    <div className="text-center mb-20">
      <h2 className="text-4xl md:text-5xl font-bold mb-6">
        Contact Us
      </h2>
      <p className="text-gray-600 max-w-xl mx-auto">
        Have questions about our HR consulting services? Our team is ready
        to help your organization build stronger teams.
      </p>
    </div>

    <div className="grid lg:grid-cols-2 gap-16">

      {/* CONTACT INFO */}
      <div>
        <h3 className="text-2xl font-semibold mb-8">
          Get In Touch
        </h3>

        <motion.div
          initial="hidden"
          animate="visible"
          variants={{
            hidden: {},
            visible: {
              transition: { staggerChildren: 0.2 }
            }
          }}
          className="space-y-6"
        >

          {contactInfo.map((item, i) => {
            const Icon = item.icon;

            return (
              <motion.div
                key={i}
                variants={{
                  hidden: { opacity: 0, y: 20 },
                  visible: { opacity: 1, y: 0 }
                }}
                whileHover={{ y: -6, scale: 1.02 }}
                transition={{ duration: 0.3 }}
                className="flex gap-4 p-6 border border-gray-200 shadow-sm hover:shadow-md"
              >

                <Icon size={28} className={item.color} />

                <div>
                  <h4 className="font-semibold text-lg">
                    {item.title}
                  </h4>
                  <p className="text-gray-700">
                    {item.content}
                  </p>
                  <p className="text-gray-500 text-sm">
                    {item.detail}
                  </p>
                </div>

              </motion.div>
            );
          })}

        </motion.div>

        {/* Map */}
        <div className="mt-12">
          <div className="h-72 bg-gray-100 rounded-lg flex items-center justify-center">
            <span className="text-gray-500">
              Google Map Integration
            </span>
          </div>
        </div>

      </div>

      {/* CONTACT FORM */}
      <div>
        <h3 className="text-2xl font-semibold mb-8">
          Send Us a Message
        </h3>

        {submitted && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className="mb-6 flex items-center gap-3 bg-green-50 border border-green-200 p-4"
          >
            <CheckCircle className="text-green-600" />
            <span className="text-green-700">
              Your message has been sent successfully.
            </span>
          </motion.div>
        )}

        <form onSubmit={handleSubmit} className="space-y-6">

          <div>
            <label className="block text-sm font-medium mb-2">
              Full Name
            </label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="w-full border border-gray-300 px-4 py-3 focus:outline-none focus:border-black"
            />
          </div>

          <div>
            <label className="block text-sm font-medium mb-2">
              Email Address
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="w-full border border-gray-300 px-4 py-3 focus:outline-none focus:border-black"
            />
          </div>

          <div>
            <label className="block text-sm font-medium mb-2">
              Message
            </label>
            <textarea
              name="message"
              rows="5"
              value={formData.message}
              onChange={handleChange}
              className="w-full border border-gray-300 px-4 py-3 focus:outline-none focus:border-black"
            />
          </div>

          <motion.button
            whileHover={{ scale: 1.08 }}
            whileTap={{ scale: 0.95 }}
            transition={{ type: "spring", stiffness: 300 }}
            className="bg-black text-white px-8 py-3 flex items-center gap-2 font-semibold"
          >
            Send Message
            <ArrowRight size={18} />
          </motion.button>

        </form>

      </div>

    </div>

  </div>

</motion.section>

);
}
